
import { OrderProduct } from "@/models/Order";
import { defineComponent, ref, PropType, computed } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import BasketItem from "@/components/BasketItem.vue";
import { NotAvailableProducts } from "@/models/Order";

export default defineComponent({
  props: {
    products: {
      type: Array as PropType<OrderProduct[]>,
      required: true,
    },
    notAvailableProducts: {
      type: Array as PropType<NotAvailableProducts[]>,
      required: true,
    },
  },
  components: {
    BasketItem,
  },
  async setup(props) {
    const store = useStore();
    const router = useRouter();
    const canEditDiscount = computed(() => store.getters.canEditDiscount);
    const activeIndex = ref<number | null>(null);

    const dir = computed(() => {
      const body = document.querySelector("body");
      return body?.getAttribute("dir");
    })

    const currencySign = computed(() => {
      return store.state.currencies.find(
        (x) => x.id == store.state.order.currencyId
      )?.symbol;
    });

    function onItemHover(index: number) {
      activeIndex.value = index;
    }

    return {
      currencySign,
      canEditDiscount,
      onItemHover,
      dir,
      activeIndex
    };
  },
});
